module.exports = __webpack_public_path__ + "img/tafsir3.c1cf0ff2.png";